/** Time-of-day greeting, e.g. "Good afternoon". */
export function getGreeting(date: Date = new Date()): string {
  const hour = date.getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

/**
 * First name from a display name. The auth layer exposes `displayName` as
 * `name || username || email || 'User'`, so this takes the first token and
 * falls back to a friendly default for empty / email-only values.
 */
export function getFirstName(displayName?: string | null): string {
  const trimmed = (displayName || '').trim();
  if (!trimmed) return 'there';
  const first = trimmed.split(/\s+/)[0];
  // Avoid greeting someone by their raw email address.
  if (first.includes('@')) return 'there';
  return first;
}
